import { Outlet } from 'react-router-dom';
import { BoxFullWH } from '../layout.styles';
import { ContentContainer } from './content-wrapper.styles';

const ContentWrapper = () => {
    return (
        <ContentContainer>
            <BoxFullWH p={2} overflow={'hidden'}>
                <Outlet />
            </BoxFullWH>
        </ContentContainer>
    );
};

export default ContentWrapper;
